export const SUPPORTED_SUBSIDY_TYPES = {
  coupon: 'coupon',
  license: 'license',
  budget: 'budget',
};

export const SUBSIDY_REQUEST_STATUS = {
  REQUESTED: 'requested',
  PENDING: 'pending',
  APPROVED: 'approved',
  DECLINED: 'declined',
  ERROR: 'error',
};
